import moment from "moment";
import React from "react";
import txnDI from "../di/servicelocator";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { previousDay } from "@domains/utils/reportDates";
import ComeqToggleBtn from "./ComeqToggleBtn";
const TxnHistoryPageTitle = (props) => {
    const device = DeviceContext();
    const txnReportDate = txnDI.transactionHistory.dateTimeTransactionGetAPI;
    if (device === null || device === void 0 ? void 0 : device.isDesktop)
        return (React.createElement("div", { className: "page-title-toggle-btn" },
            React.createElement("div", { className: "page-title" },
                React.createElement("div", { className: "DMSansMedium_28_500" }, "Transaction History"),
                !!txnReportDate && (React.createElement("div", { className: "transaction_dataTime DMSansMedium_12_500" },
                    React.createElement("div", null,
                        "Below report as on ",
                        moment(previousDay).format("DD-MMM-YY"))))),
            React.createElement(ComeqToggleBtn, { showCOMEQTOGGLE: props.showCOMEQTOGGLE, COMEQTOGGLE: props.COMEQTOGGLE, setCOMEQTOGGLE: props.setCOMEQTOGGLE })));
    return (React.createElement("div", { className: "d-flex flex-row justify-content-between  align-items-end" },
        React.createElement("div", { className: "d-flex flex-column align-items-center gap-1" },
            React.createElement("div", { className: "d-flex align-items-baseline gap-1" },
                React.createElement("span", { className: "DMSansBold_20_700 mr-7" }, "Transaction History"),
                React.createElement("div", { className: "d-flex flex-row transaction_dataTime DMSansMedium_12_500 txt_primaryGrey" },
                    React.createElement("span", { className: "mr-5" }, moment(previousDay).format("DD-MMM-YY")))),
            React.createElement(ComeqToggleBtn, { showCOMEQTOGGLE: props.showCOMEQTOGGLE, COMEQTOGGLE: props.COMEQTOGGLE, setCOMEQTOGGLE: props.setCOMEQTOGGLE }))));
};
export default TxnHistoryPageTitle;
